import {Component, Input} from '@angular/core';
import {
  ContactService,
  CustomerService,
  InsuranceCategoryService,
  InsuranceProviderService,
  ProductProviderService,
  TicketInsuranceMandateRequest,
} from '@lifeislife/lifeislife-domain';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {map, publishReplay, refCount, switchMap} from 'rxjs/operators';
import {CustomerContextService} from '../../service/customer-context-service';

@Component({
  selector: 'cf-insurance-mandate-request-list-item',
  templateUrl: './insurance-mandate-request-list-item.component.html',
  styleUrls: ['./insurance-mandate-request-list-item.component.scss'],
})
export class InsuranceMandateRequestListItemComponent {


  @Input()
  set value(v: TicketInsuranceMandateRequest) {
    this.value$.next(v);
  }

  value$ = new BehaviorSubject<TicketInsuranceMandateRequest>(null);
  providerName$: Observable<string>;
  categoryName$: Observable<string>;

  subscriberLabel$: Observable<string>;

  constructor(
    private insuranceProviderservice: InsuranceProviderService,
    private productProviderService: ProductProviderService,
    private insuranceCategoryService: InsuranceCategoryService,
    private customerContextService: CustomerContextService,
    private customerService: CustomerService,
    private contactService: ContactService,
  ) {
  }

  ngOnInit(): void {
    this.providerName$ = this.value$.pipe(
      switchMap(a => a == null ? of(null) : this.insuranceProviderservice.getInsuranceProvider$(a.insuranceProviderRef)),
      switchMap(a => a == null ? of(null) : this.productProviderService.getProductProvider$(a.productProviderRef)),
      map(p => p == null ? null : p.publicLabel),
      publishReplay(1), refCount(),
    );
    this.categoryName$ = this.value$.pipe(
      switchMap(a => this.getCategoryName$(a)),
      publishReplay(1), refCount(),
    );
    this.subscriberLabel$ = this.value$.pipe(
      switchMap(a => this.getSubscriberLabel$(a)),
      publishReplay(1), refCount(),
    );
  }

  private getCategoryName$(mandateRequest: TicketInsuranceMandateRequest) {
    if (mandateRequest == null) {
      return of(null);
    }
    if (mandateRequest.insuranceCategoryRef == null) {
      return of(mandateRequest.providerCategoryName);
    } else {
      return this.insuranceCategoryService.getInsuranceCategory$(mandateRequest.insuranceCategoryRef).pipe(
        map(c => c == null ? null : c.publicLabel),
        publishReplay(1), refCount(),
      );
    }
  }

  private getSubscriberLabel$(mandateRequest: TicketInsuranceMandateRequest) {
    if (mandateRequest == null) {
      return of(null);
    }
    if (mandateRequest.customerSubscriber) {
      const customerRef = this.customerContextService.getActiveCustomerRef();
      return this.customerService.getCustomer$(customerRef).pipe(
        map(c => this.customerService.getCustomerName(c)),
      );
    } else {
      const contactRef = this.customerContextService.getActiveContactRef();
      return this.contactService.getContact$(contactRef).pipe(
        map(c => this.contactService.getContactName(c, false)),
      );
    }
  }
}
